import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "components/common/SubmitButton";
import { TextArea } from "@progress/kendo-react-inputs";
import { useState, useCallback, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { addTimeRecord } from "services/timeService";
import { Label } from "@progress/kendo-react-labels";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import MattersCombobox from "../Postings/MattersComboBox";
import MatterDetails from "pages/MatterLedger/MatterDetails";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { getMatterRates, editTimeRecord, getTimeRecord } from "api";
import { useActiveTimeTypes } from "services/timeTypeService";
import { Tooltip } from "@progress/kendo-react-tooltip";
import infoIcon from "../../assets/CaseFileIcons/info-icon.png";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import ConfirmationDialog from "components/common/ConfirmationDialog";
import { useActiveFeeEarner } from "services/userService";
import useComboFilter, { FEE_EARNER_FIELDS } from "hooks/useComboFilter";
import { useCurrentUser } from "services/currentUserService";
import { toast } from "react-toastify";
import { formatDateForAPI } from "components/common/formatter";
import MatterAccount from "components/MatterBalances/MatterBalances";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Reveal } from "@progress/kendo-react-animation";
import { Editor, EditorTools } from "@progress/kendo-react-editor";
import { Loader } from "@progress/kendo-react-indicators";
import { FaExpand } from "react-icons/fa";
import styles from "./time.module.scss";

const {
  Bold,
  Italic,
  Underline,
  AlignLeft,
  AlignCenter,
  AlignRight,
  OrderedList,
  UnorderedList,
  Pdf,
} = EditorTools;

const AddTime = ({ fromFeeEarner, fromCaseFile, mode = "add", initialData = null, ...props }) => {
  const IS_MODAL = props.component === "modal";
  const READ_ONLY = mode === "view" || Boolean(initialData?.billed);
  const dispatch = useDispatch();
  const date = new Date();
  const [details, setDetails] = useState("");
  const [units, setUnits] = useState(1);
  const [rateInfoText, setRateInfoText] = useState(0);
  const [mpu, setMpu] = useState(6);
  const [rate, setRate] = useState(0);
  const [value, setValue] = useState(0);
  const [dateselector, setdateselector] = useState(date);
  const [matterBalanceClear, setMatterBalanceClear] = useState(false);
  const [matterRef, setmatterref] = useState(IS_MODAL ? props.matter : null);
  const { data: feeEarnerData } = useActiveFeeEarner();
  const [filteredFeeEarnerData, onFilterfeeearner] = useComboFilter(
    feeEarnerData,
    FEE_EARNER_FIELDS,
  );
  const { data: currentUser } = useCurrentUser();
  const [feeearnerref, setfeeearnerref] = useState(
    !(fromCaseFile && mode === "add") &&
      props.matter &&
      props?.matter?.feeEarnerRef && {
        userRef: props?.matter?.feeEarnerRef,
        display: `${props?.matter?.feeEarnerRef} - ${props?.matter?.feeEarnerName}`,
      },
  );
  const [error, setError] = useState(undefined);
  const { data: timetypes, loading } = useActiveTimeTypes();
  const [type, settype] = useState();
  const [fileNote, setFileNote] = useState("");
  const [notesPanelExpanded, setNotesPanelExpanded] = useState(false);
  const [notesDialogOpen, setNotesDialogOpen] = useState(false);
  const [notesDialogValue, setNotesDialogValue] = useState("");
  const [timeNoteLoading, setTimeNoteLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [initialFileNote, setInitialFileNote] = useState("");
  const showDeleteButton = IS_MODAL && (mode === "edit" || mode === "view");
  const canDelete = Boolean(initialData?.deletable);

  const openNotesDialog = () => {
    setNotesDialogValue(fileNote);
    setNotesDialogOpen(true);
  };

  const closeNotesDialog = (save) => {
    if (save) {
      setFileNote(notesDialogValue);
      setNotesPanelExpanded(true);
    }
    setNotesDialogOpen(false);
  };

  useEffect(() => {
    if ((mode === "edit" || mode === "view") && initialData) {
      setDetails(initialData.details || "");
      setUnits(initialData.units || 1);
      setMpu(initialData.mpu || 6);
      setRate(initialData.rate || 0);
      setValue(initialData.value || 0);
      setdateselector(new Date(initialData.date));
      settype({ name: initialData.timeTypeName, timeTypeID: initialData.timeTypeId });
      setmatterref({ matterId: initialData.matterId, matterRef: initialData.matterRef });
      setfeeearnerref(
        feeEarnerData?.find((feeEarner) => feeEarner.userRef === initialData.feeEarnerRef),
      );

      if (initialData.fileNoteId) {
        setNotesPanelExpanded(true);
        setTimeNoteLoading(true);
        getTimeRecord(initialData.timeId)
          .then((res) => {
            const note = res?.data?.data?.fileNote;
            if (note) {
              setFileNote(note);
              setInitialFileNote(note);
            } else {
              setInitialFileNote("");
            }
          })
          .catch(() => setInitialFileNote(""))
          .finally(() => setTimeNoteLoading(false));
      }
    }
  }, [mode, initialData]);

  useEffect(() => {
    if (mode === "add") {
      setFileNote("");
      setNotesPanelExpanded(false);
    }
  }, [mode]);

  useEffect(() => {
    if (mode !== "add") return;
    if (!fromCaseFile) return;
    if (!currentUser?.userRef || !feeEarnerData?.length) return;
    const match = feeEarnerData.find((fe) => fe.userRef === currentUser.userRef);
    if (match) setfeeearnerref(match);
  }, [mode, fromCaseFile, currentUser?.userRef, feeEarnerData]);

  const onChangematter = (event) => {
    setMatterBalanceClear(false);
    if (event.value !== null && event.value !== undefined) {
      setmatterref(event.value);
      if (event?.value?.feeEarnerRef) {
        setfeeearnerref({ userRef: event?.value?.feeEarnerRef });
      } else {
        setfeeearnerref(null);
      }
    } else {
      setMatterBalanceClear(true);
      setmatterref(undefined);
      setfeeearnerref();
    }
  };
  const onChangedateselect = (event) => {
    setdateselector(event.value);
  };
  const onChangefeeearner = (event) => {
    setfeeearnerref(event.value);
  };

  const onChangetimetype = (event) => {
    settype(event.value);
  };
  const calculateValue = useCallback(() => {
    const numericRate = Number(rate) || 0;
    const numericUnits = Number(units) || 0;
    const numericMpu = Number(mpu) || 0;

    if (numericRate > 0 && numericUnits > 0 && numericMpu > 0) {
      const calculated = (numericRate / 60) * (numericUnits * numericMpu);
      setValue(calculated);
    } else {
      setValue(0);
    }
  }, [rate, units, mpu]);
  useEffect(() => {
    calculateValue();
  }, [calculateValue]);

  const getMatterRateValue = useCallback(async () => {
    try {
      const data = await getMatterRates(matterRef?.matterId, feeearnerref.userRef);
      setRate(data?.data?.data?.rateValue);
      setRateInfoText(data?.data?.data?.rateInfo);
    } catch (error) {}
  }, [matterRef?.matterId, feeearnerref?.userRef]);

  useEffect(() => {
    if (matterRef && feeearnerref) getMatterRateValue();
  }, [matterRef, feeearnerref, getMatterRateValue]);

  const hasChanges = useMemo(() => {
    if (mode !== "edit" || !initialData) return true;
    const norm = (v) =>
      !v || (typeof v === "string" && (v.trim() === "" || v === "<p></p>")) ? "" : v;
    const sameDate = new Date(initialData.date).getTime() === dateselector.getTime();
    return (
      (initialData.details || "") !== (details || "").trim() ||
      Number(initialData.units) !== Number(units) ||
      Number(initialData.mpu) !== Number(mpu) ||
      Number(initialData.rate) !== Number(rate) ||
      Number(initialData.value) !== Number(value) ||
      !sameDate ||
      (initialData.timeTypeId ?? initialData.timeTypeID) !== type?.timeTypeID ||
      (initialData.matterId ?? initialData.matterID) !== matterRef?.matterId ||
      (initialData.feeEarnerRef || "") !== (feeearnerref?.userRef || "") ||
      norm(initialFileNote) !== norm(fileNote)
    );
  }, [
    mode,
    initialData,
    details,
    units,
    mpu,
    rate,
    value,
    dateselector,
    type?.timeTypeID,
    matterRef?.matterId,
    feeearnerref?.userRef,
    fileNote,
    initialFileNote,
  ]);

  async function handleSubmit(e) {
    e.preventDefault();

    if (READ_ONLY) {
      toast.info("This time entry is already billed and cannot be updated.");
      return;
    }

    const isEdit = mode === "edit";
    const payload = {
      timeId: isEdit ? initialData?.timeId : 0,
      matterId: matterRef?.matterId || props.matter?.matterId,
      feeEarnerRef: feeearnerref?.userRef,
      date: formatDateForAPI(dateselector),
      details,
      units,
      mpu,
      rate,
      value,
      timeTypeId: type?.timeTypeID,
      fileNote: fileNote && fileNote.trim() !== "" && fileNote !== "<p></p>" ? fileNote : null,
    };

    // Validation
    const hasError =
      !payload.matterId ||
      details.trim() === "" ||
      !units ||
      !rate ||
      !value ||
      !payload.timeTypeId;

    if (hasError) {
      setError(true);

      return;
    }

    const onSuccess = () => {
      if (props.fetchTime) props.fetchTime();
      if (fromCaseFile) props.showModal();
      else if (IS_MODAL) props.cancelEdit();
      reset();
    };

    setIsSubmitting(true);
    try {
      if (isEdit) {
        await editTimeRecord([payload]);
        toast.success("Time entry updated successfully.");
        onSuccess();
      } else {
        await dispatch(addTimeRecord({ datas: [payload], onSuccess }));
      }
    } catch (err) {
      console.error("Error submitting time:", err);
    } finally {
      setIsSubmitting(false);
    }
  }

  const reset = () => {
    setError(undefined);
    setDetails("");
    setValue(0);
    setMpu(6);
    setUnits(1);
    setRate(0);
    setFileNote("");
    setNotesPanelExpanded(false);
  };

  const handleCancel = () => {
    if (fromCaseFile) {
      props.showModal();
    } else reset();
  };

  const handleDelete = async () => {
    if (!initialData?.timeId) return;
    setIsDeleting(true);
    try {
      await editTimeRecord([{ timeId: initialData.timeId, active: false }]);
      toast.success("Time entry deleted successfully.");
      setShowDeleteConfirm(false);
      if (props.fetchTime) props.fetchTime();
      if (IS_MODAL) props.cancelEdit?.();
    } catch (err) {
      console.error("Error deleting time:", err);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex-grow-1"
      style={{ height: fromFeeEarner ? "100vh" : "calc(100% - 65px)" }}>
      <div
        className={`${
          fromFeeEarner ? "vh-100" : "mx-lg-5 mx-1 h-100"
        } d-flex justify-content-center`}>
        <div className="bgForm overflow-auto">
          <div
            className="px-lg-5 px-3 "
            style={{ maxHeight: fromFeeEarner ? "calc(100vh - 130px)" : "auto", overflow: "auto" }}>
            <div className="d-flex mt-3 align-items-start">
              <div
                className={`d-flex flex-column me-5
                ${fromFeeEarner ? "mt-5" : ""}
                `}>
                <div>
                  <Label className="label mb-1 d-block">Matter</Label>
                  <MattersCombobox
                    width={280}
                    onChangematter={onChangematter}
                    error={error === true && !matterRef && !props.matter?.matterId}
                    value={matterRef}
                    disabled={Boolean(props.matter) || READ_ONLY}
                  />
                </div>
                <div className="mt-2">
                  <Label className="label mb-1 d-block">Date</Label>
                  <DatePicker
                    className="datepicker px-2"
                    toggleButton={CalenderCustomToggleButton}
                    value={dateselector}
                    onChange={onChangedateselect}
                    disabled={READ_ONLY}
                  />
                </div>
                <div className="mt-2">
                  <Label className="label mb-1 d-block">Time Type</Label>
                  <ComboBox
                    style={{
                      textAlign: "end",
                      border: error === true && !type && "1px solid red",
                      width: "280px",
                    }}
                    data={timetypes}
                    loading={loading}
                    textField={`name`}
                    iconClassName="wa"
                    filterable={true}
                    placeholder={"Add Time Type"}
                    value={type}
                    onChange={onChangetimetype}
                    disabled={READ_ONLY}
                  />
                </div>
                <Label className="label mb-1 d-block mt-2">Fee Earner</Label>
                <ComboBox
                  style={{
                    width: "280px",
                    border:
                      error === true &&
                      (feeearnerref === null || feeearnerref === undefined) &&
                      "1px solid red",
                  }}
                  data={filteredFeeEarnerData}
                  textField={`display`}
                  iconClassName="wa"
                  filterable={true}
                  placeholder={"Search Fee Earner"}
                  value={feeearnerref}
                  onChange={onChangefeeearner}
                  onFilterChange={onFilterfeeearner}
                  disabled={READ_ONLY}
                />

                <div className="d-flex align-items-end mt-2">
                  <div className="d-flex flex-column me-3 ">
                    <Label className="label mb-1 d-block">Units</Label>
                    <NumericTextBox
                      type={"number"}
                      value={units}
                      onChange={(e) => {
                        const units = Number(e.target.value || 1);
                        setUnits(units);
                      }}
                      min={1}
                      style={{ width: "130px" }}
                      onKeyDown={(e) => {
                        if (e.key === ".") return e.preventDefault();
                      }}
                      disabled={READ_ONLY}
                    />
                  </div>
                  <div className="d-flex flex-column right-align">
                    <div className="d-flex align-items-baseline ">
                      <Label className="label mb-1 d-block">Rate</Label>
                      <Tooltip anchorElement="target" position="top">
                        <img
                          src={infoIcon}
                          title={rateInfoText}
                          className="ms-1 cursor-pointer"
                          style={{ height: "14px", width: "14px" }}
                        />
                      </Tooltip>
                    </div>
                    <NumericTextBox
                      style={{
                        textAlign: "end",
                        border: error === true && rate === 0 && "1px solid red",
                        width: "130px",
                      }}
                      width={90}
                      step={0}
                      spinners={false}
                      format={"n2"}
                      type={"number"}
                      value={rate}
                      onKeyDown={(e) => {
                        if (e.key === ".") return e.preventDefault();
                      }}
                      onChange={(e) => {
                        const rate = Number(e.target.value || 0);
                        setRate(rate);
                      }}
                      disabled={READ_ONLY}
                    />
                  </div>
                </div>
                <div className="d-flex flex-column right-align mt-2">
                  <div className="d-flex align-items-baseline ">
                    <Label className="label mb-1 d-block">Value</Label>
                    <Tooltip anchorElement="target" position="top">
                      <img
                        className="ms-1 cursor-pointer"
                        src={infoIcon}
                        title="MPU is equal to 6"
                        style={{ height: "14px", width: "14px" }}
                      />
                    </Tooltip>
                  </div>
                  <NumericTextBox
                    width={280}
                    style={{ textAlign: "right" }}
                    value={value}
                    readOnly={true}
                    placeholder="0.00"
                    spinners={false}
                    format="n2"
                    disabled={READ_ONLY}
                  />
                </div>

                <div className="d-flex my-2 flex-column mt-2">
                  <Label className="label mb-1">Details</Label>
                  <TextArea
                    value={details}
                    style={{
                      height: 100,
                      textAlign: "start",
                      width: "280px",
                      border: error === true && details === "" && "1px solid red",
                    }}
                    rows={5}
                    multiple={true}
                    placeholder="Enter Details"
                    onChange={(e) => setDetails(e.target.value)}
                    disabled={READ_ONLY}
                  />
                </div>
              </div>

              <div className="d-flex flex-column" style={{ minWidth: "320px" }}>
                <div>
                  <MatterDetails matter={matterRef} clear={matterBalanceClear} />
                </div>
                <div className="mt-3">
                  <MatterAccount
                    matterId={matterRef?.matterId || props.matter?.matterId}
                    clear={matterBalanceClear}
                  />
                </div>
                <div className="mt-3 flex-grow-1">
                  <ExpansionPanel
                    title="Notes"
                    subtitle={
                      <FaExpand
                        role="button"
                        tabIndex={0}
                        className={`cursor-pointer border-0`}
                        style={{ fontSize: "1rem", outline: "none" }}
                        title="Open in dialog"
                        onClick={(e) => {
                          e.stopPropagation();
                          openNotesDialog();
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            e.stopPropagation();
                            openNotesDialog();
                          }
                        }}
                      />
                    }
                    expanded={notesPanelExpanded}
                    onAction={() => {
                      setNotesPanelExpanded(!notesPanelExpanded);
                    }}
                    style={{ flexShrink: 0 }}
                    className="rounded-3">
                    <Reveal>
                      {notesPanelExpanded && (
                        <ExpansionPanelContent>
                          <div className="d-flex flex-column">
                            {timeNoteLoading ? (
                              <div className="d-flex justify-content-center py-3">
                                <Loader size="small" type="infinite-spinner" />
                              </div>
                            ) : (
                              <Editor
                                tools={
                                  READ_ONLY
                                    ? []
                                    : [
                                        [Bold, Italic, Underline],
                                        [OrderedList, UnorderedList],
                                        [AlignLeft, AlignCenter, AlignRight],
                                        [Pdf],
                                      ]
                                }
                                contentStyle={
                                  fromFeeEarner ? { minHeight: 195 } : { minHeight: 150 }
                                }
                                value={fileNote}
                                onChange={READ_ONLY ? undefined : (e) => setFileNote(e.html)}
                                readOnly={READ_ONLY}
                              />
                            )}
                          </div>
                        </ExpansionPanelContent>
                      )}
                    </Reveal>
                  </ExpansionPanel>
                </div>
              </div>
            </div>
            {fromFeeEarner && (
              <div>
                <div className="d-flex float-end mt-5">
                  <Button
                    className="common-btn bgBtnSecondary me-3"
                    type="button"
                    onClick={handleCancel}>
                    Cancel
                  </Button>
                  <SubmitButton
                    type="submit"
                    id="time-recording-submit"
                    isLoading={isSubmitting}
                    disabled={mode === "edit" && !hasChanges}>
                    {mode === "edit" || mode === "view" ? "Update" : "Post"}
                  </SubmitButton>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={styles.action_btn} style={{ height: "65px" }}>
        {!fromFeeEarner && (
          <DialogActionsBar>
            <div className="dialog-footer w-100 d-flex align-items-center">
              <div className="ms-4">
                {showDeleteButton && (
                  <Button
                    className="common-btn bgBtnSecondary"
                    type="button"
                    disabled={!canDelete || isDeleting}
                    onClick={() => setShowDeleteConfirm(true)}>
                    Delete
                  </Button>
                )}
              </div>
              <div className="d-flex ms-auto">
                <Button
                  className="common-btn bgBtnSecondary me-3"
                  type="button"
                  onClick={props.cancelEdit}>
                  Cancel
                </Button>
                <SubmitButton
                  type="submit"
                  id="time-recording-submit"
                  className="me-4"
                  isLoading={isSubmitting}
                  disabled={mode === "edit" && !hasChanges}>
                  {mode === "edit" || mode === "view" ? "Update" : "Post"}
                </SubmitButton>
              </div>
            </div>
          </DialogActionsBar>
        )}
      </div>

      {showDeleteConfirm && (
        <ConfirmationDialog
          content={`Are you sure you want to delete this time entry?`}
          isLoading={isDeleting}
          onClickYes={handleDelete}
          onClickNo={() => !isDeleting && setShowDeleteConfirm(false)}
          onClose={() => !isDeleting && setShowDeleteConfirm(false)}
        />
      )}

      {notesDialogOpen && (
        <Dialog title="Notes" onClose={() => closeNotesDialog(false)} className="dialog-xs">
          <div className="p-3 d-flex flex-column flex-grow-1 overflow-hidden">
            <Editor
              tools={
                READ_ONLY
                  ? []
                  : [
                      [Bold, Italic, Underline],
                      [OrderedList, UnorderedList],
                      [AlignLeft, AlignCenter, AlignRight],
                      [Pdf],
                    ]
              }
              value={notesDialogValue}
              onChange={READ_ONLY ? undefined : (e) => setNotesDialogValue(e.html)}
              readOnly={READ_ONLY}
            />
          </div>
          <DialogActionsBar>
            <div className="dialog-footer w-100 d-flex justify-content-end gap-2 px-4">
              <Button
                className="common-btn bgBtnSecondary me-2"
                onClick={() => closeNotesDialog(false)}>
                Cancel
              </Button>
              {!READ_ONLY && (
                <Button className="common-btn" onClick={() => closeNotesDialog(true)}>
                  Done
                </Button>
              )}
            </div>
          </DialogActionsBar>
        </Dialog>
      )}
    </form>
  );
};
export default AddTime;
